function NotFound() {
  return (
    <section className="min-h-screen w-full flex items-center justify-center">
      <div className="flex flex-col gap-4 text-center">
        <h1 className="font-semiBold text-6xl">404</h1>
        <p>Page not found</p>
      </div>
    </section>
  );
}

export default NotFound;
